import { updateApprovalThreshold } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const UpdateApprovalThreshold = async (
  accessToken,
  groupName,
  newApprovalThreshold
) => {
  try {
    const response = await updateApprovalThreshold(
      accessToken,
      groupName,
      newApprovalThreshold
    );
    if (response?.data.length === 0) {
      return { success: false, data: 'No data present' };
    }
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default UpdateApprovalThreshold;
